import { IJamaProjectsAndFolders } from "components/ProjectSpecificComponents/Interfaces/DataInterface"
import { TReactSelectOption } from "components/ProjectSpecificComponents/Interfaces/ExternalComponentsInterfaces"

const defaultReturn: TReactSelectOption[] = [{ value: "", label: "", isDisabled: true }]

const disableEmptyProjects = (projects: IJamaProjectsAndFolders[] | null): TReactSelectOption[] => {
	if (!projects) return defaultReturn

	const disabledOptionArr = new Array()

	projects.map(({ name, id, folders }: IJamaProjectsAndFolders) =>
		disabledOptionArr.push({
			value: id,
			label: name,
			isDisabled: !folders.length,
		})
	)

	return disabledOptionArr
}

export default disableEmptyProjects
